import classNames from "classnames";
import PropTypes from "prop-types";
import React from "react";
import Icon from "../icon/Icon";
import TextLabel from "../text-label/TextLabel";
import "./Button.scss";
import { injectIntl } from "react-intl";
import { ReactComponent as Close } from "../../../assets/img/icons/close.svg";
import { ReactComponent as TriangleDown } from "../../../assets/img/icons/triangle-down.svg";

const Button: React.SFC<any> = ({
  name,
  type = "button",
  className,
  appearance = "secondary",
  text,
  icon,
  iconSize,
  hasDropdown = false,
  onClick,
  title,
  innerRef,
  intlKey,
  intl,
  ...restOfProps
}) => {
  const availableIcons: {} = {
    close: Close,
    "triangle-down": TriangleDown
  };
  const fullClassName = classNames(
    "button",
    name && `button__${name}`,
    appearance,
    className
  );

  if (type === "button-noop") {
    type = "button";
  }
  if (intlKey) {
    text = intl.formatMessage({ id: intlKey });
  }

  return (
    <button
      type={type}
      className={fullClassName}
      onClick={onClick}
      title={title}
      ref={innerRef}
      {...restOfProps}
    >
      <div className="button__wrapper">
        {icon && (
          <Icon
            name={icon}
            size={iconSize}
            className="button__icon"
            iconComponent={availableIcons[icon]}
          />
        )}
        {text && <TextLabel name={name} text={text} />}
        {hasDropdown && (
          <Icon
            name="triangle-down"
            size="xsmall"
            iconComponent={availableIcons["triangle-down"]}
          />
        )}
      </div>
    </button>
  );
};

export default injectIntl(Button);
